/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Other_TagsInputs */

const en_dialog_other_tags = /** @type {(inputs: Dialog_Other_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other Tags`)
};

const es_dialog_other_tags = /** @type {(inputs: Dialog_Other_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otras etiquetas`)
};

/**
* | output |
* | --- |
* | "Other Tags" |
*
* @param {Dialog_Other_TagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_other_tags = /** @type {((inputs?: Dialog_Other_TagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Other_TagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_other_tags(inputs)
	return en_dialog_other_tags(inputs)
});